import { get } from '../services/common/common.service';
import { entitlementContractHistoryEndpoint } from '../constants/endpoint';

//Entitlement Search By ID - GET API to fetch the data
export const fetchEntitlementContractHistory = (payload) => {
  return get(
    `${entitlementContractHistoryEndpoint.getEntitlementContractHistory}?entitlementId=${payload.entitlementId}&recordCount=${payload.recordCount}&pageIndex=${payload.pageIndex}`,
    payload
  );
};

//Update Entitlement Contract History - GET API to update the ContractHistory for entitlement
export const updateEntitlementContractHistory = (payload) => {
  return get(
    `${entitlementContractHistoryEndpoint.updateEntitlementContractHistory}?entitlementId=${payload.entitlementId}`,
    payload
  );
};